import React from 'react'

import { LinkedInIcon, LinkIcon, TwitterXIcon } from '@slite/icons'

import { useRoutes } from '../../routes'

export default function BlogLinks({
  title,
  slug,
}: {
  title: string
  slug: string
}) {
  const routes = useRoutes()
  const link = routes.blog.post({ slug })

  const twitterLink = `https://twitter.com/intent/tweet?text=${title} ${link}`

  const linkedinLink = `https://www.linkedin.com/sharing/share-offsite/?url=${link}`

  return (
    <div className="flexbox flexbox-column-gap-20">
      <a
        href={twitterLink}
        className="shade-00 shade-10-on-hover"
        target="_blank"
        rel="noreferrer"
      >
        <TwitterXIcon size={20} />
      </a>
      <a
        href={linkedinLink}
        className="shade-00 shade-10-on-hover"
        target="_blank"
        rel="noreferrer"
      >
        <LinkedInIcon size={20} />
      </a>
      <button
        onClick={() => navigator.clipboard.writeText(link)}
        className="shade-00 shade-10-on-hover background-transparent border-none pointer"
      >
        <LinkIcon size={20} />
      </button>
    </div>
  )
}
